export default {
  SET_GIFT_CARDS(state, giftCards) {
    state.giftCards = giftCards
  },
}
